import mongoose from 'mongoose';
import wishlistSchema from '../schemas/wishlist';

export default mongoose.models.Wishlist || mongoose.model('Wishlist', wishlistSchema);
